/**
 * 오케스트레이션 공유 상태(pipeline-state.json) 단계 로그 append + 시간 유틸.
 * 휴먼인더루프 — 사용자/에이전트 행위를 해당 단계 카드 로그에 축적. dev 전용.
 */

import { type StageId } from './stageMap.js';
import { type PipelineState } from './types.js';

export function nowStr(): string {
  const d = new Date();
  const p = (n: number): string => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`;
}

/** pipeline-state.json 의 <car>.stages.<stage>.log 에 항목 append 후 POST. */
export async function appendOcLog(
  car: string,
  stage: StageId,
  msg: string,
  by: 'agent' | 'user' = 'user',
): Promise<void> {
  try {
    const res = await fetch(`data/pipeline-state.json?t=${Date.now()}`, { cache: 'no-store' });
    if (!res.ok) { console.warn('[ocLog] state fetch 실패', res.status); return; }
    const ps = (await res.json()) as PipelineState;
    const st = ps.cars?.[car]?.stages?.[stage];
    if (!st) { console.warn(`[ocLog] ${car}/${stage} 단계 없음 — 로그 skip`); return; }
    (st.log ??= []).push({ ts: nowStr(), by, msg });
    await fetch('/api/pipeline-state', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(ps),
    });
    console.log(`[ocLog] ${car}/${stage} ← ${msg}`);
  } catch (e) {
    console.warn('[ocLog] append 실패', e);
  }
}
